




























































































// import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { confirmService } from '@libs-uuif/shared/confirm-service';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { SelectedUserGroupObjectType } from './userGroupTypes';

const cssPrefix = 'permissions-container';

@Component({
  components: {
    ...UUIFComponents,
    SwCheckbox,
  },
  directives: {
    tooltip,
  },
})
export default class PermissionsContainer  extends SwExtendedVue {
  cssPrefix = cssPrefix;
  permissionCheckBox : boolean[] = [];
  formLabelWidth:string = '46%';
  editMode: boolean = true;
  permissionList: any = [];
  userGroupDataEntry: SelectedUserGroupObjectType = {
    partyGroupName: '',
    isDefaultGroup: '',
    partyGroupId: '',
    adminPartyId: '',
    status: '',
    totalContacts: '',
    productGroupName: '',
    associatedPGList: [],
    setAsDefaultGroup: '',
    renameLink: '',
    usersForUserGroup: [],
    deleteLink: '',
    mgeProdGrpPagelink: '',
    isReadOnlyAccess: '',
    MSSPID: '',
    isAllMSSPTenants: '',
    msspScope: '',
    scopedMSSPID: '',
  };
  isREstrictedMsspFromApi = '';

  discardChanges() {
    confirmService.confirm({
      status: 'major',
      title: String(this.$t('accessMgmt.usrGrpPermissions')),
      message: String(this.$t('accessMgmt.discard')),
      buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.confirm')), isDefault: true }],
    })
    .then((isConfirmed : any) => {
      if (isConfirmed === 'ok') {
        this.assignPermissionList();
        this.editMode = true;
      }
    });
  }

  onChangeEdit() {
    if (!this.editMode) {
      confirmService.confirm({
        status: 'major',
        title: String(this.$t('accessMgmt.usrGrpPermissions')),
        message: String(this.$t('accessMgmt.changePermissions')),
        buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.confirm')), isDefault: true }],
      })
      .then((isConfirmed : any) => {
        if (isConfirmed === 'ok') {
          const savePermissionList: any[] = [];
          this.permissionList.map((ele: any) => {
            if (ele.partyGroupPermissionItems) {
              ele.partyGroupPermissionItems.map((item: any) => {
                savePermissionList.push({
                  choiceid: item.value,
                  productname: item.functionalityname,
                });
              });
            }
          });
          this.$emit('setPermission', savePermissionList);
        } else {
          this.assignPermissionList();
        }
      });
    }
    this.editMode = !this.editMode;
  }

  get getpermissionList() {
    return this.$store.getters['AccessManagementStoreModule/getPermissions'];
  }

  @Watch('getpermissionList')
  assignPermissionList() {
    const permissionListVal = this.getpermissionList || [];
    this.isREstrictedMsspFromApi = this.$store.getters['AccessManagementStoreModule/getisRestrictedMSSPAccess'];
    let permissionListResp = [];
    permissionListResp = permissionListVal.map((obj: any) => {
      const editedPermissions = obj.partyGroupPermissionItems.map((ele: any) => {
        let valueSelected = '';
        ele.permissionChoices.map((item: any) => {
          if  (item.isSelected === 'TRUE') {
            valueSelected = item.permissionItemChoiceValue;
          }
        });
        return {
          functionalityname: ele.functionalityname,
          permissionChoices: ele.permissionChoices,
          value: valueSelected,
        };
      });
      return {
        partyGroupPermissionSectionName: obj.partyGroupPermissionSectionName,
        partyGroupPermissionItems: editedPermissions,
      };
    }) || [];
    this.permissionList = permissionListResp;
    this.userGroupDataEntry = this.$store.getters['AccessManagementStoreModule/getSelectedUserGroupObject'];
  }

  onChange() {
  }

  getPermissionOptions(data: any): SelectOption {
    return data.map((obj: any) => {
      return {
        id: obj.permissionItemChoiceValue,
        value: obj.permissionItemChoiceValue,
        label: obj.permssionItemChoiceName,
      };
    });
  }

  getPermissionValue(data: any) {
    let selectedMode = '';
    data.map((obj: any) => {
      if (obj.isSelected === 'TRUE') {
        selectedMode = obj.permissionItemChoiceValue;
      }
    });
    return selectedMode;
  }

  getPermissionName(data: any) {
    let selectedModeName = '';
    data.map((obj: any) => {
      if (obj.isSelected === 'TRUE') {
        selectedModeName = obj.permssionItemChoiceName;
      }
    });
    return selectedModeName;
  }

  created() {
    this.assignPermissionList();
  }
}
